import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import './Pricing.css';
import PricingHeader from '../../components/pricing/PricingHeader';
import PriceCalculator from '../../components/pricing/PriceCalculator';
import WhyChooseOurPms from '../../components/WhyChooseOurPms';
import TitleAndContentCard from '../../components/TitleAndContentCard'
import DemoRequestHeader from '../../components/pricing/DemoRequestHeader';
import DemoRequestForm from '../../components/pricing/DemoRequestForm';
import useLanguagePrefix from '../../LanguagePrefix';


function DemoRequest() {
    const langPrefix = useLanguagePrefix();

    return (
        <div>
            <Helmet>
                <title>Prostay – Request a Live Hotel Software Demo</title>
                <meta name="description" content="Book a live demo and see how Prostay can simplify hotel operations—from PMS and booking to POS and guest messaging—in one connected platform." />
                <link rel="canonical" href={"https://www.prostay.com" + langPrefix + "/request-demo/"} />

                <link rel="alternate" href="https://www.prostay.com/en/request-demo/" />
                <link rel="alternate" href="https://www.prostay.com/es/request-demo/" />

                <meta property="og:title" content="Prostay – Request a Live Hotel Software Demo" />
                <meta property="og:description" content="Book a live demo and see how Prostay can simplify hotel operations—from PMS and booking to POS and guest messaging—in one connected platform." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={"https://www.prostay.com" + langPrefix + "/request-demo/"} />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Prostay – Request a Live Hotel Software Demo" />
                <meta name="twitter:description" content="Book a live demo and see how Prostay can simplify hotel operations—from PMS and booking to POS and guest messaging—in one connected platform." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />


            </Helmet>
            <div className='demo-request'>
                <DemoRequestHeader />
                <DemoRequestForm />
            </div>
        </div>
    );
}

export default DemoRequest;
